import { SearchRounded } from "@mui/icons-material";
import { InputAdornment, TextField } from "@mui/material";
import useColors from "../../../../../../api/hooks/useColors";

export default function SearchTextField({ searchText, setSearchText }) {
  const colors = useColors();

  return (
    <TextField
      InputProps={{
        sx: {
          color: colors.contrast_text_dark,
          borderRadius: "10px",
          fontSize: "12px",
          width: "305px",
          backgroundColor: colors.common_white,
        },
        startAdornment: (
          <InputAdornment position="start">
            <SearchRounded fontSize="small" />
          </InputAdornment>
        ),
      }}
      placeholder="Search"
      type="text"
      value={searchText}
      onChange={(event) => setSearchText(event.target.value.toLowerCase())}
      sx={{
        "& .MuiInputBase-root": { height: "32px" },
        "& .MuiOutlinedInput-root": {
          "& fieldset, &:hover fieldset, &.Mui-focused fieldset": {
            borderColor: colors.textfield_border,
            borderWidth: "1px",
          },
        },
      }}
    />
  );
}
